import { ClassWithTimes, ClassWithUsers } from '../../types/routes/accountManagement';

type MinimalClassDisplayNameData = {
  nickName?: string | null;
  externalName?: string;
  section?: string | null;
  term?: string | null;
};
type ClassDisplayNameOptions = { section?: boolean; verbose?: boolean };

// Idea: show section by default only when there is an ambiguity
export const classDisplayName = (c: MinimalClassDisplayNameData, options?: ClassDisplayNameOptions): string => {
  if (c === undefined) {
    return '';
  } else {
    let sectionDisplay = '';
    if (options && options.section && c.section) sectionDisplay += ', ' + c.section;
    if (options && options.section && c.term) sectionDisplay += ', term ' + c.term;
    if (options && options.verbose && c.nickName && c.externalName) {
      return c.nickName + ' (' + c.externalName + ')' + sectionDisplay;
    } else {
      return (c.nickName ? c.nickName : c.externalName || '(Unknown)') + sectionDisplay;
    }
  }
};

export const classSectionName = (c: MinimalClassDisplayNameData): string => {
  const sectionName: string[] = [];
  if (c.section) sectionName.push('Section ' + c.section);
  if (c.term) sectionName.push('term ' + c.term);
  return sectionName.join(', ');
};

export const classSortOrder = <T extends ClassWithTimes | ClassWithUsers>(x: T, y: T): number => {
  const xName = x.nickName ? x.nickName : x.externalName;
  const yName = y.nickName ? y.nickName : y.externalName;
  return xName.toLowerCase().localeCompare(yName.toLowerCase());
};

export const keyColumn = (classCode: boolean): string => {
  return classCode ? 'Class Code' : 'Password';
};
